{
  "A1": "А1 – Початковий рівень",
  "A2": "А2 – Елементарний рівень",
  "accents_and_special_characters": "Акценти та спеціальні символи",
  "account": "Account",
  "activity": "Уроки",
  "actor": "Актор {{number}}",
  "actor_2": "Актор 2",
  "actor_name": "Ім`я актора",
  "actor_voice": "Голос актора",
  "add_alternatives": "Додати варіанти",
  "add_another_reply": "Додати ще одну відповідь",
  "add_answer": "Додати відповідь",
  "add_courses": "Додати уроки",
  "add_image": "Додати картинку",
  "add_image_desc": "Додайте картинку до вправи!",
  "add_link": "Додати посилання",
  "add_link_desc": "Додайте посилання до вправи!",
  "all_steps_complete": "Усі кроки виконано",
  "alternative_versions": "Альтернативні версії",
  "archive_recording_error": "Не вдалося заархівувати запис",
  "are_you_sure_nuala_performance": "Ви впевнені, що хочете використати оцінювання Nuala Performance?",
  "assign": "Призначити",
  "attach_file": "Прикріпити файл",
  "banner": "Банер",
  "bot_input_mobile_placeholder": "Введіть повідомлення...",
  "bot_input_placeholder": "Скористайтеся клавіатурою, щоб ввести повідомлення",
  "bot_not_found": "Чат-бот не знайдено",
  "bot_not_found_desc": "Не вдалося знайти цього чат-бота. Можливо, його видалено або зроблено приватним.",
  "audio_only_mode": "Слухай і Говори",
  "audio_only_tooltip": "Перейти в режим лише аудіо",
  "switch_to_text": "Перейти до тексту",
  "switch_to_text_tooltip": "Повернутися в текстовий режим",
  "audio_only_title": "Поговори з {{botName}}",
  "audio_only_subtitle": "Повністю усна розмова — без жодного тексту. Рекомендуються навушники.",
  "audio_only_mode_unavailable_fallback_chat": "Ця вправа потребує режиму «Слухати й говорити», але він недоступний на цьому пристрої — продовження в режимі чату.",
  "microphone_ready": "Мікрофон готовий",
  "bot_is_speaking": "Говорить...",
  "thinking_indicator": "Обмірковує...",
  "start_conversation": "Почати розмову",
  "stop_button_label": "Зупинити",
  "stop_bot_message": "Зупинити голос чат-бота",
  "choose_mode_text_option": "Чат",
  "choose_mode_text_option_desc": "Введи або скажи свої відповіді, а потім читай або слухай відповіді бота.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Повторити",
  "replay_bot_message": "Повторити повідомлення чат-бота",
  "you": "Ти",
  "ready_when_you_are": "Готово, коли будеш готовий",
  "bot_speaking_banner": "{{botName}} говорить",
  "listening_to_you": "Слухаю тебе",
  "bot_thinking_banner": "{{botName}} обмірковує",
  "one_moment": "Хвилинку",
  "listen_first": "Спочатку послухай",
  "tap_when_done": "Натисни, коли закінчиш",
  "conversation_complete": "Розмову завершено",
  "exchanges_label": "Обміни",
  "time_spoken_label": "Час розмови",
  "review_your_turns": "Переглянути свої репліки",
  "submit_to_teacher": "Надіслати вчителю",
  "great_job": "Чудова робота!",
  "card": "Картка",
  "categories": "Категорії",
  "chart": "Діаграма",
  "chatgpt_roleplay_description": "Це сценарій про {{topic}}",
  "check_answer": "Перевірити відповідь",
  "choose_difficulty_of_roleplay": "Виберіть складність сценарію",
  "choose_length_of_roleplay": "Виберіть тривалість сценарію",
  "choose_topic_for_roleplay": "Виберіть тему для сценарію",
  "classroom_invite_feature_disabled_message": "Цю функцію вимкнено, оскільки ваші учні зможуть приєднатися до цього класу автоматично.",
  "clear": "Очистити",
  "close_pdf": "Закрити PDF",
  "comma_seperated_domains": "Домени, розділені комами",
  "community": "Спільнота",
  "datetime": "Дата й час",
  "days": "днів",
  "days_late": "Запізнення на {{count}} днів",
  "discussion": "Обговорення",
  "download_error": "Не вдалося завантажити файл",
  "editor_mode": "Режим редактора",
  "email_notifications": "Сповіщення електронною поштою",
  "emoji_quiz": "Вікторина з емодзі",
  "emoji_quiz_desc": "Вгадайте відповідь за емодзі.",
  "empty_live_dialog_description": "Додайте курс, якщо хочете грати наживо в класі.",
  "enter_linguistic_goal": "Введіть лінгвістичну мету",
  "add_new": "Додати нове",
  "add_phrase": "Додати фразу",
  "add_phrase_desc": "Додати нову {{language}} фразу для вивчення",
  "add_phrases": "Додати фрази",
  "add_phrases_to_enable_exercise": "Додати фрази до можливих вправ",
  "add_question": "Додати запитання",
  "add_question_desc": "Додати запитання на розуміння, Це запитання може мати кілька правильних відповідей.",
  "add_review": "Додати рецензію",
  "add_review_desc": "Поділитися думками нижче",
  "add_script": "Додати Сценарій",
  "add_section": "Додати розділ",
  "add_substitution": "Додати заміну",
  "add_substitution_desc": "З цією заміною, ви можете побачити 'те що' розширено в 'те що' замінено, (–) дозволяючи вам краще контролювати те, як ви відповідаєте на повідомлення користувача!",
  "add_topic": "Додати тему",
  "add_topic_desc": "Теми є логічним групуванням вступів. Коли користувач перебуває в темі, він може відповідати лише вступам, які належать до цієї теми.",
  "add_topic_to_section": "Додати тему до {{sectionId}} відділу",
  "add_trigger": "Додати вступ",
  "add_trigger_desc": "Вступ-це рядок тексту, який використовується для відповідності повідомленню користувача.",
  "add_variable": "Додати змінну",
  "add_variable_desc": "Змінні бота - це фрагменти інформації, які описують вашого бота. За допомогою змінних бота, ми можемо писати відповіді, в яких бот може розповісти користувачеві дещо про себе.",
  "add_voice": "Додати голос",
  "all": "Усе",
  "all_topics_completed": "Усі теми завершено",
  "alternatives": "Варіанти",
  "alternatives_desc": "Список слів або фраз, які можна повторно використовувати у вашому боті.",
  "alternatives_name": "Ім`я",
  "alternatives_value": "Список слів (розділено комами)",
  "answer": "Відповідь",
  "new_answer_placeholder": "Введіть свою відповідь тут",
  "answer_message_100": "Ідеально, Молодець",
  "answer_message_90": "Ви досягаєте результатів, Продовжуйте намагатися",
  "answer_message_95": "Майже правильно, Ви на правильному шляху",
  "answer_message_wrong": "Це було не зовсім правильно",
  "answer_method": "Метод відповідей",
  "answers": "Відповіді",
  "attempt": "Спроба",
  "attempt_info": "Інформація про спробу",
  "attempt_messages": "Вправа на спробу",
  "attempt_table": "Спроби",
  "auto_translate": "Дозволити учням перекладати повідомлення рідною мовою",
  "auto_translate_phrase": "Автоматичний переклад фрази",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1 - Середній",
  "B2": "B2 - Вище середнього",
  "back": "Повернутися",
  "back_to_course": "Повернутися до уроку",
  "blog": "Блог",
  "bot": "Бот",
  "bot-listen-and-speak": "Бот — Слухай і Говори",
  "all_modes": "Усі режими",
  "bot_information": "Інформація бота",
  "bot_intro_message": "Вступне повідомлення бота",
  "bot_intro_message_helper_text": "Залиште порожнім, якщо хочете, щоб учень почав розмову.",
  "bot_name": "Ім`я бота",
  "bot_outputs": "Виходи бота",
  "bot_reply": "Відповідь бота",
  "bot_settings": "Налаштування бота",
  "bot_title": "Назва бота",
  "bot_voice": "Голос бота",
  "bots": "Боти",
  "bots_not_found_desc": "Створи першого бота сьогодні",
  "bots_not_found_title": "Ботів не знайдено",
  "C1": "C1 - Просунутий",
  "C2": "C2 - Майстерний",
  "cancel": "Скасувати",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Змінити кольори застосунку",
  "change_language": "Змінити мову",
  "chatbot_exercise_desc": "Поспілкуйтесь з ботом, щоб імітувати розмову на певну тему",
  "chatbots": "Чат-боти",
  "choose_avatar": "Вибрати Nuala",
  "choose_from_file": "Вибрати з файлу",
  "classroom_code": "Код класу",
  "classroom_code_label": "Ввести код класу",
  "classroom_code_not_valid": "Код класу недійсний",
  "classroom_created": "Класна кімната створена",
  "classroom_deleted": "Класна кімната видалена",
  "classroom_information": "Інформація класної кімнати",
  "classroom_name": "Ім`я класної кімнати",
  "classroom_not_found": "Класна кімната не знайдена",
  "classroom_not_found_desc": "Можливо, ця класна кімната була видалена",
  "classroom_load_error": "Не вдалося завантажити класну кімнату",
  "classroom_load_error_desc": "Під час завантаження цієї класної кімнати сталася помилка. Спробуйте ще раз.",
  "classroom_settings": "Налаштування класної кімнати",
  "classrooms": "Класні кімнати",
  "classrooms_not_found_desc": "Створити перші класні кімнати сьогодні",
  "classrooms_not_found_title": "Класні кімнати не знайдено",
  "collaborators": "Співавтори (додатково)",
  "color": "Колір",
  "community_templates": "Шаблони спільнот",
  "completed": "Виконано",
  "completed_icon": "Завершена ікона",
  "completion": "Завершення",
  "completions": "Доробки",
  "confirmation": "Підтвердження",
  "contact_form": "Зв`яжіться з нами",
  "continue": "Продовжити",
  "continue_exercise": "Продовжити Вправу",
  "continue_learning": "Продовжити Навчання",
  "continue_teaching": "Продовжити Викладання",
  "copied": "Скопійовано",
  "copy_to_clipboard": "Копіювати в буфер обміну",
  "correct": "Виправити",
  "correct_answer": "Виправити Відповідь",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Урок",
  "course_code": "Код Уроку",
  "course_code_label": "Ввести код уроку",
  "course_code_not_valid": "Код уроку недійсний",
  "course_created": "Урок створено",
  "course_deleted": "Урок видалено",
  "course_information": "Інформація про урок",
  "course_name": "Ім`я уроку",
  "course_not_found": "Урок не знайдено",
  "course_not_found_desc": "Можливо, цей урок було видалено",
  "course_outline": "Конспект уроку",
  "course_progress": "Прогрес уроку",
  "course_settings": "Налаштування уроку",
  "courses": "Уроки",
  "courses_not_found_desc": "Створити перші уроки сьогодні",
  "courses_not_found_title": "Уроки не знайдено",
  "create": "Створити",
  "create_bot": "Створити бот",
  "create_classroom": "Створити класну кімнату",
  "create_course": "Створити Урок",
  "create_course_section": "Створити розділ уроку",
  "create_course_section_desc": "Ви самі вирішуєте, як структурувати занаття, Приклади структур 'Початковий, Середній, Просунутий' або 'Тиждень 1, Тиждень 2, Тиждень 3'",
  "create_duplicate": "Створити Дублікат",
  "create_topic": "Створити тему",
  "created_courses": "Створені уроки",
  "creation_visibility": "Загальнодоступний контент можна використовувати як початкову точку для завдань інших педагогів.",
  "creator": "Творець",
  "creator_instructions": "Інструкції вчителя",
  "creator_instructions_placeholder": "Ви можете додати відформатовану інструкцію для співавтора уроку тут\n\ne.g. \"Ласкаво просимо до бота, Ось як налаштувати для своїх учнів...\"",
  "customization": "Налаштування",
  "dark_theme": "Темна тема",
  "dark_theme_desc": "Перетворює світлі поверхні сторінки на темні, створюючи ідеальне зображення ночі.",
  "date": "Дата",
  "delete_bot": "Видалити Бот",
  "delete_bot_confirmation": "Ви впевнені, що хочете видалити цей бот?",
  "delete_classroom": "Видалити класну кімнату",
  "delete_classroom_confirmation": "Ви впевнені, що хочете видалити цю класну кімнату?",
  "delete_course": "Видалити урок",
  "delete_course_confirmation": "Ви впевнені, що хочете видалити цей урок?",
  "delete_phrase": "Видалити Фразу",
  "delete_phrase_confirmation": "Ви впевнені, що хочете видалити цю фразу?",
  "delete_picture": "Видалити Картинку",
  "delete_review": "Видалити Відгук",
  "delete_review_confirmation": "Ви впевнені, що хочете видалити цей відгук?",
  "delete_roleplay": "Видалити рольову гру",
  "delete_roleplay_confirmation": "Ви впевнені, що хочете видалити цю рольову гру?",
  "delete_section": "Видалити розділ",
  "delete_section_confirmation": "Ви впевнені, що хочете видалити цей розділ?",
  "delete_topic": "Видалити тему",
  "delete_topic_confirmation": "Ви впевнені, що хочете видалити цю тему?",
  "description": "Опис",
  "difficulty": "Складність",
  "difficulties": "Рівні складності",
  "disable": "Вимкнути",
  "disabled": "Вимкнено",
  "display": "Дисплей",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Завантажити",
  "drop_csv_file_or_click_to_upload": "Перетягніть CSV файл або натисніть, щоб завантажити.",
  "edit": "Редагувати",
  "edit_bot": "Редагувати Бот",
  "edit_discussion": "Редагувати Обговорення",
  "edit_roleplay": "Редагувати Рольову Гру",
  "email": "Електронна пошта",
  "enable": "Увімкнути",
  "enabled": "Увімкнено",
  "enrolment_key": "Ключ реєстрації",
  "enrolment_key_not_valid": "Ключ реєстрації недійсний",
  "enter_private_key": "Ввести закритий ключ",
  "error_generating_discussion": "Не вдалося створити обговорення",
  "exercise": "Вправа",
  "exercise_complete": "Вправа виконана",
  "exercise_completed_icon": "{{name}} виконано {{counter}} раз",
  "exercise_completion": "виконана {{exercise}} вправа '{{id}}'",
  "exercise_in_progress": "почата {{exercise}} вправа '{{id}}'",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_info": "Інформація про вправу",
  "exercise_no_longer_available": "Ця вправа більше недоступна",
  "exercises": "Вправи",
  "exercises_completed": "Вправи завершено",
  "exercises_completed_icon": "{{name}} виконано {{counter}} разів",
  "exit": "Вийти",
  "expand": "Розгорнути",
  "fill_in_contact_form": "Будь ласка, заповніть форму нижче",
  "find_bot": "Знайти бот",
  "find_classroom": "Знайти класну кімнату",
  "find_course": "Знайти урок",
  "find_roleplay": "Знайти рольову гру",
  "finish": "Завершити",
  "finish_exercise": "Завершити вправу",
  "for_lang": "Я говорю",
  "formatting_options": "Параметри форматування",
  "fri": "Птн",
  "from": "З",
  "fullscreen": "Повний екран",
  "generate_definitions_info": "Створіть визначення для фраз у цьому списку.",
  "generate_roleplay": "Створити сценарій",
  "generating": "Створення",
  "get_started": "Почати",
  "go_back": "Повернутись",
  "go_back_to_topic": "Повернутись до теми",
  "go_to": "Go to",
  "go_to_settings": "Перейти до налаштувань",
  "group_information_form_title": "Розкажіть про свою групу",
  "group_member_limit": "Обмеження учасників групи",
  "group_name": "Назва групи",
  "group_picture": "Зображення групи",
  "group_subscription_form_title": "Налаштуйте підписку групи",
  "help": "Довідка",
  "hidden": "Приховано",
  "hide": "Приховати",
  "hide_bot": "Приховати бот",
  "hide_chatbots_exercise": "Приховати боти",
  "hide_listening_exercise": "Приховати вправу на аудіювання",
  "hide_menu": "Приховати Меню",
  "hide_options": "Приховати параметри",
  "hide_pronunciation_exercise": "Приховати вправу на вимову",
  "hide_roleplay": "Приховати рольову гру",
  "hide_roleplays_exercise": "Приховати рольові ігри",
  "hide_section": "Приховати розділ",
  "hide_topic": "Приховати тему",
  "hide_translation_exercise": "Приховати вправу на переклад",
  "hide_word_bank": "Приховати вивчені слова",
  "home": "Початкова сторінка",
  "how_to_join_find_button": "Знайдіть кнопку {{button}} і натисніть її.",
  "how_to_join_get_ready": "Приготуйтеся грати.",
  "how_to_join_intro": "Щоб приєднатися до гри, виконайте ці кроки:",
  "how_to_join_open_classroom": "Відкрийте клас {{classroom}} або відскануйте QR-код нижче",
  "how_to_join_sign_in": "Увійдіть до свого облікового запису.",
  "how_to_join_title": "Як приєднатися до гри",
  "in_game": "У грі",
  "in_progress": "Продовжити грати",
  "incorrect": "Неправильно",
  "insert_bold": "Вставити жирний шрифт",
  "insert_italic": "Вставити шрифт-курсив",
  "insert_link": "Вставити посилання",
  "insert_photo": "Вставити фото",
  "instruction_message": "Інструкції",
  "join": "Доєднати",
  "join_classroom": "Доєднати класну кімнату",
  "join_code_desc": "Учні можуть ввести код нижче, щоб приєднатися",
  "join_course": "Доєднати Урок",
  "join_date": "Дата приєднання",
  "joined": "Приєднано",
  "joined_classroom": "Приєднано до класної кімнати",
  "joined_course": "Приєднано до уроку",
  "language": "Мова",
  "language_phrase": "{{language}} Фраза",
  "language_translation": "{{language}} Переклад",
  "learn": "Вчити",
  "learn_for_speakers_of": "{{learnLang}} для {{forLang}} тих, хто розмовляє",
  "learn_lang": "Я хочу навчатися",
  "left_classroom": "Клас покинуто",
  "left_course": "Курс покинуто",
  "lets_begin": "Почнімо",
  "load_more": "Завантажити ще",
  "loading": "Завантаження",
  "loading_topics": "Завантаження тем",
  "meaning-listen-and-speak": "Значення — слухай і говори",
  "meaning-read-and-write": "Значення — читай і пиши",
  "meaning_listen_and_speak_exercise_desc": "Прослухайте визначення та вимовте відповідну фразу.",
  "more_definitions": "Більше визначень",
  "more_translations": "Більше перекладів",
  "new": "Нове",
  "no_chatbot_templates": "Немає доступних шаблонів",
  "no_phrases": "Немає фраз",
  "no_topics_available": "Немає доступних тем",
  "not_in_game": "Не у грі",
  "nuala_performance_rating": "Оцінювання Nuala Performance",
  "nudge_add_family_name_field_desc": "Додайте прізвище, щоб викладачі могли вас упізнати.",
  "nudge_add_family_name_profile_desc": "Додайте прізвище до профілю, щоб викладачі могли вас упізнати.",
  "nudge_add_family_name_title": "Додайте прізвище",
  "on": "о",
  "open_ended": "Відкрите запитання",
  "open_ended_desc": "Дозвольте учням відповідати своїми словами.",
  "open_image_library": "Відкрити бібліотеку зображень",
  "perfect_click_finish_create_group": "Чудово! Натисніть «Завершити», щоб створити групу.",
  "phrase_group_game_in_progress_icon": "{{name}} у процесі",
  "phrase_lists_error": "Не вдалося завантажити списки фраз",
  "picture_quiz": "Вікторина із зображеннями",
  "picture_quiz_desc": "Ставте запитання на основі зображень.",
  "player": "гравець",
  "players": "гравці",
  "please_select_a_textfield": "Виберіть текстове поле",
  "preview_pdf": "Перегляд PDF",
  "print": "Друк",
  "questions": "Запитання",
  "quiz": "Вікторина",
  "quiz_desc": "Проведіть учня через серію запитань.",
  "quiz_style_templates": "Шаблони у стилі вікторини",
  "recommended": "Рекомендовано",
  "record_unsupported": "Цей браузер не підтримує запис",
  "refresh": "Оновити",
  "result": "Результат",
  "retry": "Повторити",
  "roleplay_generated": "Сценарій створено",
  "roleplay_information": "Інформація про сценарій",
  "roleplay_not_found": "Сценарій не знайдено",
  "roleplay_not_found_desc": "Не вдалося знайти цей сценарій. Можливо, його видалено або зроблено приватним.",
  "save_definitions_error": "Не вдалося зберегти визначення",
  "scenarios": "Сценарії",
  "schedule": "Запланувати",
  "script_not_found": "Сценарій не знайдено",
  "script_not_found_desc": "Не вдалося знайти цей сценарій. Можливо, його видалено або зроблено приватним.",
  "search_images": "Пошук зображень",
  "see_more_pronunciations": "Переглянути більше вимов",
  "select_roleplay": "Вибрати сценарій",
  "select_the_correct_answer": "Виберіть правильну відповідь",
  "send": "Надіслати",
  "show_phrase_list": "Показати список фраз",
  "skip_navigation": "Пропустити навігацію",
  "student_limit": "Обмеження учнів",
  "submit": "Надіслати",
  "submitting": "Надсилання",
  "subscription": "Підписка",
  "subscription_period_end": "Кінець періоду підписки",
  "subscription_status": "Статус підписки",
  "table": "Таблиця",
  "teach": "Навчати",
  "leave_classroom": "Залишити класну кімнату",
  "leave_classroom_confirmation": "Ви впевнені, що хочете залишити цю класну кімнату?",
  "leave_course": "Залишити урок",
  "leave_course_confirmation": "Ви впевнені, що хочете залишити це урок?",
  "library": "Бібліотека",
  "link_name": "Назва посилання",
  "link_name_helper_text": "Введіть ім`я, що відображується для свого посилання",
  "link_value": "Посилання Url",
  "link_value_helper_text": "Введіть Url для свого посилання",
  "listen_to_this_phrase": "Прослухайте цю {{language}} фразу",
  "listener": "Слухач",
  "listener_dialog_desc": "Виберіть голос нижче, щоб прослухати вимову",
  "listening": "Аудіювання",
  "listening_exercise_desc": "Чи можете ви зрозуміти, що було сказано?",
  "load_more_events": "Завантажити більше подій",
  "logout": "Вийти",
  "manage_course": "Керувати уроком",
  "members": "Cтуденти ",
  "members_not_found": "Немає учасників",
  "members_not_found_desc": "Учасників не знайдено",
  "message": "Повідомлення",
  "method": "Метод",
  "missing_details": "Відсутні деталі",
  "mon": "Пн",
  "more_options": "Більше варіантів",
  "my_courses": "Мої уроки",
  "name": "Ім`я",
  "new_bots": "Нові боти",
  "new_courses": "Нові уроки",
  "new_roleplays": "Нові рольові ігри",
  "next": "Наступне",
  "next_with_progress": "Наступне ({current} з {total})",
  "no_activity_found": "Завдання не знайдено",
  "no_courses_found": "Занять не знайдено",
  "no_results_found": "Результати не знайдені",
  "nualang_templates": "Шаблони",
  "only_available_on_chrome": "Доступне лише на Google Chrome",
  "open_in_google_sheets": "Відкрити в Google таблицях",
  "open_search_student_name_filters": "Open search student name filters",
  "option": "Варіант",
  "optional": "Додаткове",
  "or_choose_from_one_of_the_following": "Або виберіть один із нижченаведених",
  "percentage_complete": "Percentage Complete",
  "phrase": "Фраза",
  "phrases": "Фрази",
  "play_again": "Грати знову",
  "plays": "{{number}} Ігри",
  "popular_courses": "Популярні уроки",
  "preview": "Попередній перегляд",
  "previous": "Попередній",
  "private": "Приватний",
  "problem": "Виникла проблема",
  "problem_creating": "Виникла проблема при створенні",
  "problem_deleting": "Під час видалення виникла проблема",
  "problem_getting_reply": "Виникла проблема з отриманням відповіді",
  "problem_loading": "Виникла проблема із завантаженням",
  "problem_sending_contact_form": "Проблема з надсиланням контактної інформації",
  "profile": "Профіль",
  "profiles": "профілі",
  "progress_icon": "Значок прогресу",
  "pronounce_this_phrase": "Вимовте цю фразу",
  "pronunciation": "Вимова",
  "pronunciation_exercise_desc": "Практикуйте вимову фраз",
  "public": "Спільнота",
  "question": "Запитання",
  "new_question_placeholder": "Введіть своє запитання тут",
  "quit": "Вийти",
  "record_message": "Записати повідомлення",
  "records": "Аудіозаписи",
  "redo_action": "Переробити",
  "remove": "Видалити",
  "remove_bot": "Видалити бота",
  "remove_card": "Remove Card",
  "remove_roleplay": "Видалити рольову гру",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Відповісти",
  "reply_options": "Варіанти відповідей",
  "reply_options_are_disabled": "Варіанти відповідей вимкнено",
  "reply_options_desc": "Дозвольте студентам вибрати правильну відповідь із списку варіантів",
  "report_views": "Views",
  "required_for_private_classrooms": "Необхідний для приватних класів",
  "required_for_private_courses": "Необхідний для приватних занять",
  "reset": "Скинути",
  "restart_exercise": "Перезапустити вправу",
  "return_to_course": "Повернутися до уроку",
  "review_content": "Огляд вмісту",
  "review_title": "Назва огляду",
  "reviews": "Відгуки",
  "reviews_not_found": "Немає відгуків",
  "reviews_not_found_desc": "Відгуки не знайдені",
  "role_played": "Роль розіграна",
  "roleplay": "Рольова гра",
  "roleplay_exercise_desc": "Сформулюйте та дайте відповіді на запитання з діалогу між двома людьми",
  "roleplays_not_found_desc": "Створіть першу рольову гру сьогодні",
  "roleplay_name": "Назва рольової гри",
  "roleplay_settings": "Налаштування рольової гри",
  "roleplays": "Рольові ігри",
  "sat": "Сб",
  "save_changes": "Зберегти зміни",
  "save_progress": "Зберегти прогрес",
  "show_progress": "Показати прогрес",
  "script": "Сценарій",
  "search": "Пошук",
  "search_for_student": "Пошук для студента",
  "section": "Розділ",
  "section_name": "Назва розділу",
  "section_visibility": "Видимість розділу",
  "sections_not_found": "Розділи не знайдені",
  "sections_not_found_desc": "",
  "select_a_template": "Виберіть шаблон",
  "select_file": "Виберіть файл",
  "select_file_desc": "Перетягніть файл сюди або натисніть, щоб запустити механізм",
  "select_files": "Вибрати файли",
  "select_the_from_date": "Виберіть дату початку",
  "select_the_to_date": "Виберіть До дати",
  "settings": "Налаштування",
  "share": "Поділитися",
  "share_via": "Поділитися через",
  "show_bot": "Показати бот",
  "show_chatbots_exercise": "Показати боти",
  "show_listening_exercise": "Показати вправу з аудіювання",
  "show_menu": "Показати меню",
  "show_options": "Показати варіанти",
  "show_pronunciation_exercise": "Показати вправу на вимову",
  "show_roleplay": "Показати рольову гру",
  "show_roleplays_exercise": "Показати рольові ігри",
  "show_section": "Показати розділ",
  "show_topic": "Показати тему",
  "show_translation_exercise": "Показати вправу на переклад",
  "show_word_bank": "Показати Word Bank",
  "skip": "Пропустити",
  "skip_copy_topic": "Пропустити",
  "skipped": "Пропущено",
  "speak": "Говорити",
  "speakers_of": "Доповідачі",
  "start": "Почати",
  "start_course": "Почати урок",
  "stop": "Зупинитись",
  "stop_recording": "Зупинити запис",
  "student_instructions": "Інструкції для студентів",
  "student_instructions_placeholder": "Інструкції для студентів:\nВи можете додати своє форматоване повідомлення з інструкціями сюди\n\ne.g. \"Ласкаво просимо до бота, ви можете почати, ввівши привіт\"",
  "subject": "Тема",
  "substitution_desc": "Внести зміни в повідомлення користувача перед перевіркою вступу.",
  "substitution_name": "Текст оригіналу",
  "substitution_name_helper_text": "Текст оригіналу, який, напевно, з`явиться у повідомленні користувача",
  "substitution_value": "Текст заміни",
  "substitution_value_helper_text": "Не має містити жодних спеціальних знаків чи знаків пунктуації, а також має бути написано малими літерами",
  "substitutions": "Заміни",
  "sun": "Нд",
  "text": "Текст",
  "thank_you_for_submitting": "Дякуємо за надсилання, ми зв`яжемся з вами якомога швидше.",
  "the_default_topic_is_random": "Тема за замовчуванням є випадковою",
  "thu": "Чт",
  "time": "Час",
  "time_spent": "Витрачений час",
  "to": "До",
  "toggle_theme": "Перемикати світлу/темну тему",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Тема",
  "topic_code": "Код теми",
  "topic_desc": "Коли користувач перебуває в темі, він може відповідати лише вступам, які належать до цієї теми.",
  "topic_image": "Зображення теми",
  "topic_information": "Інформація про тему",
  "topic_settings": "Налаштування теми",
  "topic_title": "Назва теми",
  "topic_name": "Ім`я теми",
  "topic_not_found": "Тему не знайдено",
  "topic_not_found_desc": "Тема, напевно, була видалена",
  "topics": "Теми",
  "translate": "Перекласти",
  "translate_is_disabled": "Перекладач вимкнено",
  "translate_this_phrase": "Перекладіть цю фразу",
  "translation": "Переклад",
  "translation_exercise_desc": "Перевірте свої мовні навички, перекладаючи фрази",
  "translations": "Переклади",
  "trigger_value": "Текст вступу",
  "trigger_value_helper_text": "Не має містити жодних спеціальних знаків чи знаків пунктуації, а також має бути написано малими літерами",
  "triggers": "Вступи",
  "triggers_desc": "Вступ - це рядок тексту, який використовується для відповідності повідомленню користувача .",
  "tue": "Вт",
  "type": "Надрукувати",
  "unarchive": "Розархівувати",
  "undo_action": "Скасувати",
  "update": "Оновити",
  "update_image": "Оновити зображення",
  "update_link": "Оновити посилання",
  "update_phrase": "Оновити фразу",
  "update_phrase_desc": "Внести зміни в цю фразу, що існує",
  "update_picture": "Оновити картинку",
  "update_question": "Оновити запитання",
  "update_question_desc": "Поставте запитання на розуміння, Запитання може мати декілька правильних відповідей.",
  "update_recording_error": "Не вдалося оновити запис",
  "update_review": "Оновити огляд",
  "update_review_desc": "Оновити опис огляду",
  "update_section": "Оновити розділ",
  "update_section_desc": "Ви вирішуєте, як структурувати уроки, Приклади - 'Початковий, Середній, Продвинутий' або 'Тиждень 1, Тиждень 2, Тиждень 3'",
  "update_substitution": "Оновити заміну",
  "update_topic": "Оновити тему",
  "update_trigger": "Оновити вступ",
  "update_variable": "Оновити змінну",
  "upgrade": "Покращити план",
  "upload_phrases": "Оновити фрази",
  "upload_phrases_desc": "Створити та завантажити csv файл, як подано у прикладі нижче.",
  "upload_phrases_example_phrase_1": "привіт",
  "upload_phrases_example_phrase_2": "до побачення",
  "upload_phrases_example_phrase_3": "мене звати",
  "upload_phrases_example_definition_1": "Слово, яке використовують для вітання",
  "upload_phrases_example_definition_2": "Слово, яке використовують при прощанні",
  "upload_phrases_example_definition_3": "Фраза для того, щоб сказати комусь своє ім'я",
  "upload_script": "Завантажити сценарій",
  "upload_script_desc": "Завантажити сценарій рольової гри з файлом csv, використовуючи наведений формат нижче",
  "use_keyboard": "Використовувати клавіатуру",
  "use_word_bank": "Використовувати Word Bank",
  "user_message": "Повідомлення користувача",
  "user_updated": "Користувач оновлений",
  "using_nuala_performance": "Якщо ви скористаєтеся оцінюванням Nuala Performance, усі створені вручну оцінки буде втрачено.",
  "variable_desc": "Фрагменти інформації, які можна використовувати у вашому боті.",
  "variable_name": "Ім`я змінної",
  "variable_value": "Змінне значення",
  "variables": "Змінні",
  "vars": "Змінні",
  "view_activity": "Переглянути завдання",
  "view_instruction_message": "Переглянути інстукцію",
  "view_outline": "Переглянути структуру",
  "view_progress": "Переглянути прогрес",
  "view_report": "Переглянути звіт",
  "visibility": "Видимість",
  "visit_learning_site": "Перейти на Learning Site",
  "voice": "Голос",
  "voice_speed_disabled": "Швидкість мовлення недоступна для цього голосу",
  "wed": "Ср",
  "weekly_progress": "Щотижневий прогрес",
  "what_do_you_hear": "Що ви чуєте?",
  "word_bank": "Word Bank",
  "active_now": "Зараз активний",
  "choose_a_language": "Вибрати мову",
  "manage_classroom": "Керуйте класною кімнатою ",
  "must_question_least_correct_answer": "Має бути запитання та принаймні одна правильна відповідь.",
  "enter_name_your_voice_clip": "Введіть назву голосового кліпу",
  "my_unnamed_clip": "Мій безіменний кліп",
  "are_you_sure": "Ви впевнені?",
  "is_already_created_variable_overwrite": "є вже створена змінна, чи ви хочете її перезаписати?",
  "is_already_created_substitution_overwrite": "є вже створена заміна, чи ви хочете її перезаписати?",
  "is_already_created_alternative_overwrite": "є вже створена альтернатива, чи ви хочете її перезаписати?",
  "is_already_created_topic_overwrite": "є вже створена тема, чи ви хочете її перезаписати?",
  "bring_your_bot_picture_name": "Оживіть свого бота, надавши йому зображення та назву",
  "perfect_click_finish_create_bot": "Чудово, Натисніть Готово, щоб створити нового бота",
  "lets_start_with_some_information_about_your_bot": "Розпочнемо з інформації про вашого бота",
  "lets_start_some_information_about_classroom": "Розпочнемо з інформації про вашу класну кімнату",
  "the_language_classroom_teach": "Мова, якою навчатимуть у класі",
  "the_language_students_classroom_speak": "Мова, якою студенти будуть спілкуватись у класі",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Обмежте доступ до своєї класної кімнати, налаштувавши видимість на приватну та увімкнувши ключ реєстрації",
  "add_collaborators": "Додайте співавторів",
  "perfect_click_finish_create_classroom": "Чудово, Натисніть Готово, щоб створити нову класну кімнату",
  "perfect_click_finish_create_course": "Чудово, Натисніть Готово, щоб створити ваш новий урок",
  "lets_start_information_about_course": "Розпочнемо з інформації про ваш урок",
  "the_language_course_teach": "Мова, яку ви будете вивчати на цьому уроці",
  "the_language_students_course_speak": "Мова, якою розмовлятимуть студенти цього уроку",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Обмежте доступ до своєї класної кімнати, налаштувавши видимість на приватну та увімкнувши ключ реєстрації",
  "selected": "Вибрано",
  "perfect_click_finish_create_roleplay": "Чудово, Натисніть Готово, щоб створити свою нову рольову гру",
  "lets_start_with_information_about_roleplay": "Розпочнемо з інформації про вашу рольову гру",
  "play_bot": "Включити бота",
  "invite": "Запросити",
  "unanswered_table": "Без відповіді",
  "create_roleplay": "Створити рольову гру",
  "roleplays_not_found_title": "Рольових ігор не знайдено",
  "play": "Грати",
  "delete": "Видалити",
  "use_wordbank_if_stuck": "Використовуйте word bank, якщо потрібна допомога",
  "play_bot_error": "Ой! Виникла проблема з ботом, спробуйте знову",
  "bot_editor_preview_error": "Сталася помилка. Зверніться до вікна довідки (значок - знак запитання) у верхній частині екрану.",
  "lets_find_a_template": "Давайте знайдемо шаблон!",
  "search_by_difficulty": "Пошук за складністю",
  "search_using_keywords": "Пошук за ключовими словами",
  "select_a_nualang_template": "Вибрати шаблон Nualang",
  "select_a_nualang_template_desc": "Шаблони, створені командою Nualang, щоб допомогти вам розпочати навчання.",
  "or_select_a_community_template": "Або виберіть шаблон спільноти",
  "or_select_a_community_template_desc": "Шаблони спільнот створюються вчителями з усього світу.",
  "dashboard_welcome": "Ласкаво просимо, {{name}}!",
  "dashboard_welcome_desc": "Ознайомтесь з інформаційною панеллю, ось кілька способів, як почати.",
  "enter_course_code": "Ввести код уроку",
  "enter_course_code_desc": "Якщо у вас є код уроку, введіть його тут.",
  "enter_classroom_code": "Введіть код класної кімнати",
  "enter_classroom_code_desc": "Якщо у вас є код класної кімнати, введіть його тут.",
  "search_nualang": "Дослідити Nualang",
  "search_nualang_desc": "Спільнота вчителів-однодумців, які спілкуються з нашими студентами Nualas зростає, тому завжди є чому повчитися.",
  "create_nualang": "Створити свій власний",
  "create_nualang_desc": "Створюйте розмови та уроки мови.",
  "roleplay_editor_welcome": "Почати роботу з редактором рольових ігор",
  "roleplay_editor_options": "Вибрати опцію",
  "roleplay_editor_options_desc": "Виберіть Nuala, щоб додати новий рядок, або додайте запитання на розуміння.",
  "roleplay_editor_share": "Поділитися рольовою грою",
  "roleplay_editor_play": "Розіграти рольову гру",
  "bot_editor_welcome": "Почати роботу з редактором ботів",
  "bot_editor_sidebar": "Бічна панель редактора",
  "bot_editor_sidebar_desc": "На бічній панелі ви можете вносити зміни до свого бота.",
  "bot_editor_flow_chart": "Потік ботів",
  "bot_editor_flow_chart_desc": "Потік бота показує огляд вашого бота та надає попередній перегляд того, як виглядатиме кожне повідомлення.",
  "bot_editor_share": "Поділитися ботом",
  "bot_editor_play": "Запустити бота",
  "play_roleplay": "Розіграти рольову гру",
  "customize_appearance_of_course": "Налаштувати зовнішній вигляд уроку",
  "customize_appearance_of_classroom": "Налаштувати зовнішній вигляд класної кімнати",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "manage_courses": "Керувати уроками",
  "refresh_courses": "Оновити уроки",
  "delete_script_item": "Видалити елемент із сценарію",
  "delete_script_item_confirmation": "Ви впевнені, що хочете видалити цей елемент із сценарію?",
  "add_message": "Додати повідомлення",
  "resources": "Ресурси",
  "contact": "Контакт",
  "sign_in": "Увійти",
  "sign_up": "Зареєструватися",
  "faqs": "Найчастіші запитання",
  "guides": "Орієнтири",
  "back_to_app": "Повернутися до програми",
  "notes": "Нотатки",
  "notes_placeholder": "Ввести нотатки тут",
  "get_in_touch": "Залишатись на зв`язку",
  "get_in_touch_desc": "Маєте запитання чи відгуки? Відправте нам повідомлення.",
  "avatar_generator": "Генератор аватарів",
  "avatar_generator_desc": "Створіть свій власний аватар",
  "upload_image": "Завантажити зображення",
  "upload_image_desc": "Перетягніть зображення з комп`ютера",
  "random": "Випадковий",
  "done": "Зроблено",
  "file_size_exceeded": "Зображення завеликого формату! Будь ласка, завантажте зображення меншого формату ",
  "image_selection_failed": "Не вдалося завантажити це зображення. Спробуйте інше або завантажте своє власне.",
  "remove_course": "Видалити урок",
  "courses_joined": "Уроки додані",
  "courses_added": "Курси додано",
  "problem_adding_courses": "Виникла проблема під час додавання цих курсів",
  "classroom_courses_not_found_title": "Ще немає занять",
  "classroom_courses_not_found_desc": "У цій класній кімнаті ще немає занять.",
  "in_progress_activity": "В процесі",
  "bot_exercise_welcome": "Почати роботу із вправою бота",
  "bot_exercise_restart": "Перезапустіть бота!",
  "bot_exercise_keyboard_input": "Введіть!",
  "bot_exercise_keyboard_input_desc": "Використати клавіатуру, щоб надрукувати повідомлення. Якщо вам потрібна допомога зі спеціальними символами або ви хочете додати смайлики, скористайтеся нашими корисними кнопками.",
  "bot_exercise_voice_input": "Проговоріть!",
  "bot_exercise_voice_input_desc": "Натиснути на мікрофон, щоб записати свій голос та попрактикувати вимову.",
  "bot_exercise_send_message": "Відправте!",
  "bot_exercise_send_message_desc": "Надіслати повідомлення боту та почати розмову.",
  "bot_exercise_audio_only_mic": "Проговоріть!",
  "bot_exercise_audio_only_mic_desc": "Натисни на мікрофон, щоб почати. Після цього просто говори природно — Нуала слухатиме і відповідатиме автоматично протягом усієї розмови.",
  "roleplay_exercise_welcome": "Почати роботу із вправою Рольова гра",
  "roleplay_exercise_read_script": "Вивчіть свої репліки!",
  "roleplay_exercise_read_script_desc": "Прочитати розмову та прослухати, як вимовляються слова.",
  "roleplay_exercise_select_an_actor": "Виберіть свою роль!",
  "roleplay_exercise_select_an_actor_desc": "Вибрати роль, яку б ви хотіли зіграти.",
  "roleplay_exercise_start": "Розіграйте!",
  "roleplay_exercise_start_desc": "Натиснути 'Пуск' і за допомогою клавіатури або голосу розіграйте вибрану роль.",
  "listening_exercise_welcome": "Почати роботу з вправою на аудіювання",
  "listening_exercise_speak": "Прослухайте фразу!",
  "listening_exercise_speak_desc": "Натиснути, щоб прослухати, як вимовлється фраза.",
  "listening_exercise_voice_options": "Прослухайте інший голос!",
  "listening_exercise_voice_options_desc": "Послухати фразу, вимовлену різними голосами.",
  "listening_exercise_keyboard_input": "Введіть відповідь!",
  "listening_exercise_keyboard_input_desc": "За допомогою клавіатури ввести почуту фразу.",
  "listening_exercise_word_bank": "Потрібна допомога?",
  "listening_exercise_word_bank_desc": "Використати word bank, щоб вибрати правильну відповідь.",
  "translation_exercise_welcome": "Почати роботу із вправою Переклад",
  "translation_exercise_speak": "Прослухайте фразу!",
  "translation_exercise_speak_desc": "Натиснути, щоб прослухати, як вимовляється фраза.",
  "translation_exercise_read": "Прочитайте фразу!",
  "translation_exercise_read_desc": "Прочитати фразу, яку необхідно перекласти.",
  "translation_exercise_keyboard_input": "Введіть відповідь!",
  "translation_exercise_keyboard_input_desc": "Використати клавіфтуру, щоб надрукувати відповідь.",
  "translation_exercise_word_bank": "Потрібна допомога?",
  "translation_exercise_word_bank_desc": "Використати word bank, щоб вибрати правильну відповідь.",
  "pronunciation_exercise_welcome": "Почати роботу із вправою на вимову",
  "pronunciation_exercise_speak": "Прослухайте фразу!",
  "pronunciation_exercise_speak_desc": "Натиснути, щоб прослухати, як вимовляється фраза.",
  "pronunciation_exercise_read": "Прочитайте фразу!",
  "pronunciation_exercise_read_desc": "Прочитати фразу, яку необхідно повторити.",
  "pronunciation_exercise_voice_input": "Вимовіть фразу!",
  "pronunciation_exercise_voice_input_desc": "Натиснути мікрофон, щоб попрактикувати вимову своїм голосом.",
  "exercise_share": "Поділіться з іншими!",
  "exercise_mute": "Вимкни звук!",
  "exercise_skip": "Пропустіть!",
  "exercise_skip_desc": "Перейти до наступної фрази, ви зможете повторити спробу в кінці.",
  "exercise_restart": "Перезапустіть!",
  "what_would_you_like_to_do": "Чим ви хотіли зайнятись?",
  "i_want_to_learn": "Я хочу вивчати...",
  "i_want_to_teach": "Я хочу навчати...",
  "add_alternative_version": "Додати альтернативну версію",
  "language_translation_helper_text": "Натиснути клавішу enter / return key, щоб додати переклад.",
  "change_roles": "Помінялися ролями?",
  "write_your_feedback_here": "Напишіть свій відгук тут",
  "yes": "Так",
  "you_are_human": "Якщо ви людина, залиште це поле порожнім",
  "you_are_human_check": "Підтвердьте, що ви людина",
  "you_will_lose_your_progress_on_this_exercise": "Ви втратите прогрес у цій вправі.",
  "confirm": "Підтвердити",
  "general": "Загальне",
  "shuffle_phrases": "Перемішати фрази",
  "shuffle_phrases_desc": "Довільно визначити порядок запитань у вправах.",
  "errors": "Помилки",
  "missing_translation": "Відсутній переклад",
  "missing_phrase": "Відсутня фраза",
  "invalid_image_domain": "URL-адреса зображення має бути зі схваленого домену Nualang",
  "row": "Ряд",
  "no_valid_type": "Надруковано має бути 'актор' або 'запитання'",
  "no_actor_text": "Текст для актора відсутній",
  "no_actor_number": "Актор повинен мати номер в кінці, наприклад, актор1, актор2",
  "no_question": "Запитання відсутнє",
  "no_answers_provided": "Відповіді не надано",
  "no_correct_answer_provided": "Немає правильної відповіді",
  "no_answers": "Відповіді відсутні",
  "duplicate_topic": "Продублювати тему",
  "normal_mode": "Нормальний режим",
  "spreadsheet_mode": "Режим електронної таблиці",
  "image": "Зображення",
  "delete_selected_row": "Видалити вибраний рядок",
  "crop_image": "Обрізати зображення",
  "crop": "Обрізати",
  "zoom": "Збільшити",
  "rotate": "Обернути",
  "hide_preview": "Приховати попередній перегляд",
  "show_preview": "Показати попередній перегляд",
  "try_again": "Спробувати знову",
  "subscription_plan_teach": "План навчання",
  "subscription_plan_teacher_pro": "Вчитель Професіонал",
  "subscription_plan_basic": "Базовий вчитель",
  "subscription_plan": "План підписки",
  "subscription_status_trialing": "Безкоштовна спроба",
  "subscription_status_active": "Активний",
  "subscription_status_canceled": "Скасовано",
  "subscription_status_undefined": "Вільний",
  "status": "Статус",
  "upgrade_plan": "Оновити план",
  "manage_plan": "Керувати планом",
  "cancel_plan": "Скасувати план",
  "your_plan": "Ваш план",
  "plan_cost": "Вартість плану",
  "next_billing_date": "Кінець поточного періоду",
  "free": "Безкоштовний",
  "payment_method": "Спосіб оплати",
  "confidence_score": "Відсоток достовірності вказує на ймовірність того, що окремі слова були розпізнані правильно.",
  "first_name": "Ім`я",
  "last_name": "Прізвище",
  "role": "Роль",
  "school_name": "Назва школи",
  "school_district": "Район школи",
  "city": "Місто",
  "state": "Країна",
  "send_message": "Відправити повідомлення",
  "pricing_page_title": "Вибрати ваш план",
  "pricing_page_subtitle": "Бланк цін для вчителів та студентів.",
  "pricing_page_testimonials_title": "Що говорять вчителі",
  "compare_plans": "Порівняти плани",
  "features": "Функції",
  "upgrade_submit": "Оновити",
  "upgrade_subscription_desc": "Щоб отримати доступ до цієї функції, вам потрібно оновити обліковий запис. Натисніть 'Оновити', щоб перейти на сторінку цін.",
  "upgrade_plan_explanation": "Щоб отримати доступ до цієї функції, вам потрібно оновити обліковий ваш запис.",
  "upgrade_subscription_student": "Ця функція є доступною лише для вчителів.",
  "public_visibility_disabled_wayside": "Класами керує Wayside Publishing, тому вони мають залишатися приватними.",
  "public_visibility_disabled_loading": "Ми ще перевіряємо вашу підписку. Оновіть сторінку, якщо це не зміниться.",
  "public_visibility_disabled_trial": "Публічні класи недоступні під час безкоштовного пробного періоду. Перейдіть на платний план, щоб зробити цей клас публічним.",
  "creator_not_subscribed": "До цього контенту не можна приєднатися, так як автор оскільки не підписаний.",
  "sign_me_up": "Зареєструвати мене!",
  "free_trial": "БЕЗКОШТОВНА спроба",
  "interactive_demo": "Отримати демо-версію",
  "news_and_updates": "Новини та Оновлення",
  "teacher": "Вчитель",
  "principal": "Директор",
  "tutor": "Репетитор",
  "parent": "Батько",
  "student": "Студент",
  "other": "Інше",
  "none": "Жоден із перечислених",
  "group_subscription_plans": "Плани групових пісписок",
  "group_plan": "План групи",
  "leave_group": "Залишити групу",
  "joined_subscription": "Приєднався до підписки",
  "joined_subscription_desc": "Ласкаво просимо до {{groupName}} групи, зараз ви використовуєте 'Вчитель-Професіонал'!",
  "unable_to_join_subscription": "Не вдалося приєднатися до підписки",
  "unable_to_join_subscription_desc": "Виникла проблема з приєднанням до підписки, повторіть спробу пізніше.",
  "unable_to_join_subscription_invalid_email_desc": "Ви не можете приєднатися до цієї групи, не маючи одного із дозволених доменів електронної пошти: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' досягла ліміту учасників, зверніться до адміністратора групи, щоб збільшити ліміт .",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Зображення заблоковано",
  "recommended_courses": "Рекомендовані уроки",
  "subscription_status_trialing_expired": "Термін дії безкоштовної версії закінчився",
  "no_public_content_created": "Загальнодоступний вміст не створено",
  "add_tag": "Натисніть enter / return key щоб додати теги",
  "add_collaborator_tag": "Натисніть enter / return key щоб додати співавтора",
  "add_to_classroom": "Додати до класів",
  "add_to_classroom_desc": "Додати '{{courseName}}' до {{classroomNames}}.",
  "change_voice_speed": "Змініть швидкість голосу!",
  "extra_fast": "Супер швидкість",
  "fast": "Дуже швидко говорить",
  "medium": "Нормальна швидкість",
  "slow": "Трохи сповільнити",
  "extra_slow": "Одне слово за раз",
  "card_ALL": "Все",
  "join_classroom_to_access": "Щоб отримати доступ - приєднайтеся до класної кімнати",
  "join_course_to_access": "Щоб отримати доступ - приєднайтеся до уроку",
  "confidence": "Впевненість",
  "teach_lang": "Я хочу навчати",
  "write_feedback": "Написати відгук",
  "allowed_domains": "Дозволити домени школи (додатково)",
  "add_allowed_domains_desc": "Обмежити доступ на основі домену школи, наприклад, 'schooldomain.com'",
  "send_feedback": "Відправити відгук",
  "add_feedback": "Додати відгук",
  "feedback_content": "Вміст відгуку",
  "report_problem": "Повідомити про проблему",
  "report_problem_input_label": "Опис проблеми",
  "update_feedback": "Оновити відгук",
  "student_completes_exercise": "Коли студент виконує вправу",
  "delete_feedback_confirmation": "Ви впевнені, що хочете видалити цей відгук?",
  "delete_feedback": "Видалити відгук",
  "updates_to_our_terms_of_service": "Оновлення наших умов використання",
  "email_me_when": "Надішліть нам електронний лист, коли:",
  "new_classroom": "Нова класна кімната",
  "student_progress": "Прогрес студента",
  "view_course": "Переглянути урок",
  "view_section": "Переглянути розділ",
  "classroom_members_not_found_title": "Ще немає учасників",
  "classroom_members_not_found_desc": "У цій класній кімнаті ще немає учасників.",
  "open_topic": "Відкрити тему",
  "choose_game_mode": "Вибрати режим гри",
  "story": "Історія",
  "story_description": "Прослухайти розмову між персонажами та дати відповіді на запитання, щоб перевірити розуміння сказанного.",
  "fill_in_blanks": "Заповнити пропуски",
  "fill_in_blanks_description": "Чи можете ви правильно визначити, чого не вистачає?",
  "fill_in_the_blanks": "Заповнити пропуски",
  "fill_in_the_blanks_description": "Чи можете ви правильно визначити, чого не вистачає?",
  "act_it_out": "Розіграти",
  "act_it_out_description": "Чи можете ви вибрати правильну відповідь?",
  "act_it_out_listening": "Розіграти - Аудіювання",
  "act_it_out_listening_description": "Використайте свої слухові навички, щоб вибрати правильну відповідь.",
  "act_it_out_speaking": "Розіграти - Говоріння",
  "act_it_out_speaking_description": "Відпрацюйте свою вимову, промовляючи свою частину.",
  "act_it_out_listening_speaking": "Розіграти - Аудіювання та Говоріння",
  "act_it_out_listening_speaking_description": "Відпрацюйте свою вимову, промовляючи свою частину.",
  "select_role": "Вибрати свою роль",
  "select_role_description": "Виберіть роль, яку б ви хотіли зіграти.",
  "mute": "Вимкнути звук",
  "unmute": "Увімкнути звук",
  "replay": "Перезапустити",
  "restart": "Перезапустити",
  "click_to_speak": "натисніть, щоб говорити",
  "click_to_stop": "натисніть, щоб зупинити",
  "listening_indicator": "Аудіювання ...",
  "save_recording_to_report": "Зберегти запис для звіту",
  "no_voice_recording_saved": "Запис голосу не був збережений",
  "classrooms_not_created": "No classrooms selectable",
  "select_a_classroom": "Вибрати класну кімнату",
  "voice_attempt": "Спроба голосу",
  "upload_variables": "Завантажити змінні",
  "next_game": "Наступна гра",
  "roleplay_games": "Рольові ігри",
  "roleplay_games_description": "Натиснути на одну із поданих карт нижче, щоб зіграти певну роль",
  "group_courses": "Урок групи",
  "select": "Вибрати",
  "classroom_creator_welcome": "Почати роботу у класній кімнаті",
  "classroom_creator_add_courses": "Додати урок",
  "classroom_creator_add_students_email": "Запросити студентів",
  "classroom_creator_track_progress": "Відстежувати діяльність студентів",
  "classroom_creator_track_progress_desc": "Коли студенти приєднаються до класної кімнати, натисніть, щоб переглянути їхній прогрес на уроках, які були додані.",
  "forLang_and_learnLang_the_same": "Мова для вивчення та мова спікера є однаковими. Тому вправа на переклад вимкнена",
  "english": "Англійська",
  "french": "Французька",
  "german": "Німецька",
  "irish": "Ірландська",
  "italian": "Італійська",
  "portuguese": "Португальська",
  "spanish": "Іспанська",
  "close": "Закрити",
  "last": "Останній",
  "update_avatar": "Оновити аватар",
  "update_avatar_desc": "Оновити свій аватар",
  "invite_students": "Запросити студентів",
  "share_student_link_desc": "Поділитися інструкціями, наведеними нижче, щоб запросити студентів приєднатися.",
  "invite_link_desc": "Будь ласка, увійдіть або створіть обліковий запис в Nualang, натиснувши на запрошувальне посилання:",
  "join_instructions_1": "Це приведе вас до ",
  "join_instructions_2": "Я створив для вас, де потрібно буде натиснути ‘Приєднатися’",
  "enrollment_key_text": "і ввести ключ: ",
  "copy_student_instructions": "Скопіювати інструкції студента",
  "or_invite_via": "Або запросити через",
  "classroom": "Класна кімната",
  "invite_email_subject": "Запрошення, щоб приєднатися до Nualang",
  "dear_students": "Дорогі студенти",
  "dashboard": "Панель приладів",
  "preview_roleplay": "Попередній перегляд рольової гри",
  "roleplay_preview": "Попередній перегляд",
  "roleplay_preview_decription": "Переглянути повний сценарій рольової гри",
  "sort": "Сортувати",
  "sort_by": "Сортувати за",
  "newest": "Найновіші",
  "alphabetical": "За алфавітом",
  "recently_changed": "Нещодавно змінені",
  "recently_viewed": "Нещодавно переглянуті",
  "oldest": "Найстаріші",
  "default": "За умовчанням",
  "member": "Учасник",
  "stop_speaking": "Припини говорити",
  "agree_to_terms_and_conditions_1": "Я погоджуюсь на ",
  "nualang_terms": "умови Nualang ",
  "agree_to_terms_and_conditions_2": ", включаючи прийняття наших ",
  "privacy_policy": "політики конфіденційності та захисту даних",
  "first_classroom_description": "Це класна кімната, щоб допомогти студентам заговорити {{learnLang}} з впевненістю.",
  "upload": "Завантажити",
  "download": "Завантажити",
  "classroom_creator_add_students_email_desc": "Натиснути, щоб дослідити різні способи для запрошення студентів до класних кімнат.",
  "bot_sign_in_message": "Ви повинні увійти, щоб грати в цього бота",
  "course_sign_in_to_access": "Увійти, щоб мати доступ до цього уроку",
  "have_an_account": "Вже маєте обліковий запис?",
  "provide_a_little_more_information": "Надати трохи більше інформації",
  "instructions": "Інструкції",
  "close_preview": "Закрити попередній перегляд",
  "check_recognition": "Перевірити розпізнавання мовлення",
  "checking_recognition": "Перевірка розпізнавання мовлення ...",
  "phrase_recognised": "Фраза розпізнана",
  "phrase_not_recognised": "Фраза нерозпізнана",
  "speech_recognition_info": " Перевірка розпізнавання мовлення дозволяє визначити, чи будуть ваші студенти відчувати труднощі з вимовою цієї фрази під час наших вправ.",
  "speech_recognition_error_info": "Ми розпізнали вашу фразу, як {{recognisedPhrase}}. Ми рекомендуємо вам змінити фразу та/або додати альтернативну версію.",
  "my_library": "Моя Бібліотека",
  "add_own_exercise_message": "Створити нову {{exerciseName}} за допомогою створених вами шаблонів",
  "no_exercises_in_library": "Ви не створили {{exerciseName}}.",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Привіт! Мене звати {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "whats_new": "What's New",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "page": "Page",
  "unknown": "Невідомий",
  "add_a_discussion_topic": "Додати Тему Обговорення",
  "add_a_url_for_students_to_discuss": "Додати URL для обговорення студентами",
  "images_that_students_can_use_as_a_background_during_the_call": "Зображення, які студенти можуть використовувати як фон під час дзвінка",
  "discussion_images": "Зображення для обговорення",
  "images_for_students_to_discuss_during_the_call": "Зображення для обговорення студентами під час дзвінка",
  "recording_time": "Час запису",
  "due_date": "Крайній термін",
  "interculturarity": "Міжкультурність",
  "comprehensibility": "Зрозумілість",
  "function_and_text_type": "Функція і Тип тексту",
  "vocabulary_in_context": "Словник в контексті",
  "Drag_and_drop_image_from_your_computer": "Перетягніть і відпустіть зображення з вашого комп'ютера",
  "record_time_limit": "Обмеження часу запису",
  "schedule_discussion_options": "Параметри планування обговорення",
  "chat_options": "Параметри чату",
  "recording_info": "Submission Info",
  "discussion_id": "ID обговорення",
  "discussion_prompt": "Завдання для обговорення",
  "attendees": "Учасники",
  "created_discussions": "Створені обговорення",
  "create_groups": "Створити Групи",
  "select_all": "Вибрати Все",
  "remove_group": "Видалити Групу",
  "grouped_discussions": "Групові обговорення",
  "no_recordings_found": "Записи не знайдені",
  "recordings": "Записи",
  "scheduled_meetings": "Заплановані зустрічі",
  "no_meetings_scheduled": "Зустрічі не заплановані",
  "discussion_info": "Інформація про обговорення",
  "invites": "Запрошення",
  "invited_members": "Запрошені Учасники",
  "minute": "Хвилина",
  "feedback": "Зворотний Зв'язок",
  "view": "Перегляд",
  "no_data_found": "Дані Не Знайдені",
  "no_past_discussions_found": "Не Знайдено Жодних Попередніх Обговорень",
  "no_submissions_found": "Не Знайдено Подань",
  "background_images": "Фонові Зображення",
  "no_scheduled_discussions_found": "Не Знайдено Запланованих Обговорень",
  "view_more": "Дивитися Більше",
  "past": "Минуле",
  "submissions": "Подання",
  "add_a_discussion_prompt": "Додати Завдання для Обговорення",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Медалі живої гри",
  "live_game_medals_description": "Розблокуйте медалі, посівши 1-е, 2-е або 3-є місце під час живої гри",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "Розмова недоступна",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Створено Обговорення",
  "discussion_updated": "Обговорення оновлено",
  "give_feedback": "Дати Зворотний Зв'язок",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "create_feedback": "Create Feedback",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Обговорень не знайдено",
  "no_discussions_found_desc": "Усі обговорення та подання можна знайти тут",
  "quality_of_interaction": "Якість Взаємодії",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Обговорювати",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Надає зворотній зв'язок всім учасникам групи обговорення. Ви не можете надати одночасно груповий та індивідуальний зворотний зв'язок студенту.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Інформація про рубрику",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Шаблони Обговорень",
  "discussion_templates_desc": "Використовуйте один із наших попередньо визначених шаблонів обговорення, щоб допомогти вам створити контент для своїх студентів",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_grouped_discussions": "Груповані обговорення",
  "discuss_grouped_discussions_desc": "Тут ви можете знайти всі обговорення, які ви створили для своїх учнів за назвою теми. Клацніть на групове обговорення, щоб побачити, які групи учнів було створено.",
  "discuss_submissions": "Обговорення заяв",
  "discuss_submissions_desc": "Тут ви можете знайти записи обговорень, створені групами учнів. Ви можете переглянути їх запис, а також транскрипцію обговорень і надати індивідуальну або групову зворотню зв'язок.",
  "discuss_welcome": "Посібник з Обговорень",
  "discuss_scheduled_discussions": "Заплановані Обговорення",
  "discuss_scheduled_discussions_desc": "Тут ви знайдете заплановані обговорення, створені вчителем. Ви зможете приєднатися до цих обговорень і говорити про тему з іншими студентами вашої групи.",
  "discuss_refresh_discussions": "Оновити Обговорення",
  "discuss_refresh_discussions_desc": "Ця кнопка дозволить вам оновити, щоб отримати останні заплановані обговорення.",
  "discuss_recorded_discussions": "Запис Обговорень",
  "discuss_recorded_discussions_desc": "Here you can find discussions you have recorded and submitted for the teacher to review. Once feedback is given you will be able to view it.",
  "refresh_discuss": "Оновити Обговорення",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "nuala_ai": "Нуала ШІ",
  "performance_ratings": "Оцінки продуктивності",
  "attended": "Відвідав",
  "did_not_attend": "Не відвідав",
  "discussion_attendance": "Участь у дискусіях",
  "submitted_recordings": "Подані записи",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Додайте альтернативну версію фрази, яку потрібно позначити як правильну, наприклад 'You are welcome' може бути альтернативою для 'You're welcome'",
  "upload_video": "Завантажити Відео",
  "select_video_desc": "Перетягніть відео з вашого комп'ютера",
  "add_video": "Додати Відео",
  "video_info": "Відео Курсу",
  "play_video": "Відтворити Відео",
  "delete_video": "Видалити Відео",
  "delete_video_confirmation": "Ви впевнені, що хочете видалити це відео?",
  "view_video": "Переглянути Відео",
  "video_options": "Параметри Відео",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Видалити запитання",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "close_drawer": "Close Drawer",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "incomplete_translation": "There is still more to this sentence!",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Українська",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Під час пошуку сталася помилка, спробуйте ще раз",
  "create_feedback_error": "Під час створення відгуку сталася помилка, спробуйте ще раз",
  "get_recs_error": "Сталася помилка під час отримання записів",
  "get_image_error": "Сталася помилка під час отримання зображень",
  "update_discussion_error": "Під час оновлення обговорення сталася помилка, спробуйте ще раз",
  "invite_users_error": "Під час запрошення користувачів сталася помилка, спробуйте ще раз",
  "create_image_error": "Під час завантаження зображення сталася помилка, спробуйте ще раз",
  "grade_conversation_error": "Під час оцінювання розмови сталася помилка, спробуйте ще раз",
  "get_transcript_error": "Під час отримання транскрипту сталася помилка, спробуйте ще раз",
  "get_subs_error": "Під час отримання подань сталася помилка, спробуйте ще раз",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Під час планування обговорення сталася помилка, спробуйте ще раз",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Студент вручну відредагував цю транскрипцію після запису.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Між вибраними класами немає спільних курсів.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Hello",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Мовне виправлення",
  "correction_original": "Оригінал",
  "correction_suggested": "Пропозиція",
  "language_corrections_to_review": "Мовні виправлення для повторення",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Налаштування рівня користувача",
  "chatbot_dynamic_responses": "Чат-бот - Динамічні відповіді",
  "chatbot_dynamic_responses_desc": "Якщо ввімкнено динамічну відповідь, чат-бот активно слухатиме та адаптуватиметься, запитуючи більше деталей, чіткіше формулювання або реалістичні відповіді, замість того, щоб просто переходити до наступної запрограмованої підказки.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? How the new Chatbot works",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Turn off all AI in this classroom. Chatbots will use their scripted replies, and AI feedback on Discuss recordings will be unavailable.",
  "limit_ai_info": "Limiting AI turns off every AI feature in this classroom at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot dynamic responses",
  "chatbot_ai_desc": "Chatbots use AI to reply to what students say. When off, they use the scripted replies they were built with.",
  "discuss_ai": "Discuss AI feedback",
  "discuss_ai_desc": "AI-generated feedback on Discuss recordings. When limited, teachers can still write their own feedback.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is limited for this classroom. Chatbots will use their original scripted replies, and AI feedback is unavailable for Discuss recordings.",
  "ai_locked_notice": "AI is limited for your whole organisation, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organisation, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Chatbot dynamic responses are allowed for this classroom, but limited for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "Наведена нижче транскрипція потребує вашого перегляду.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Студент поводиться неналежно під час вправи з чат-ботом",
  "or": "або",
  "ai_chatbot_error_response": "Sorry I made a mistake in my response. please try again!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "progress": "Progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "select_the_correct_phrase": "Виберіть правильну фразу для цього визначення",
  "chinese": "Китайська",
  "custom_feedback_title": "Індивідуальний відгук (необов’язково)",
  "custom_feedback_placeholder": "Необов’язково: додайте додаткові інструкції, щоб уточнити відгук (наприклад, точність, складність або використання цільових структур).",
  "generate_feedback_view_the": "Переглянути",
  "generate_feedback_rubric_name": "Аналітична рубрика зростання",
  "generate_feedback_rubric_desc": "критерії, що використовуються в нашому зворотному зв'язку ШІ.",
  "late_submission": "Запізніле Подання",
  "days_late_one": "{{count}} день запізнення",
  "days_late_other": "{{count}} днів запізнення",
  "phrase_definition": "Визначення фрази",
  "phrase_definition_helper_text": "Натиснути клавішу enter / return key, щоб додати визначення.",
  "generate_definitions": "Згенерувати визначення",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Списки фраз",
  "no_phrase_lists": "Немає списків фраз",
  "all_phrase_lists": "Усі списки фраз",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Під час створення визначень виникла проблема. Спробуйте ще раз.",
  "saving_defintions_error": "Під час збереження визначень виникла проблема. Спробуйте ще раз.",
  "auto_generate_definitions": "генерувати визначення",
  "generating_definitions": "Генерация определений",
  "definitions": "Определения",
  "view_phrase_list": "Переглянути список фраз",
  "defintions": "Определения",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Копіювати до",
  "transfer": "Копіювати",
  "create_phrase_list_from_selection": "Створити новий список фраз",
  "no_other_phrase_lists": "Немає інших списків фраз",
  "add_row": "Додати рядок",
  "problem_updating": "Виникла проблема при оновленні",
  "exercise_settings": "Налаштування вправ",
  "excercise_voice": "Голос вправи",
  "excercise_voice_desc": "Виберіть голос, який буде використовуватись у вправах для цього списку фраз.",
  "excercise_visibility": "Видимість вправ",
  "keyboard": "Клавіатура",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Ласкаво просимо до вправи «Читай і Пиши»",
  "read_write_exercise_definition": "Визначення",
  "read_write_exercise_definition_desc": "Прочитайте визначення, показане тут",
  "read_write_exercise_options": "Введіть фразу",
  "read_write_exercise_options_desc": "Введіть правильну фразу в текстовому полі",
  "read_the_definition": "Прочитайте визначення",
  "type_the_correct_phrase": "Введіть правильну фразу",
  "read_write": "Читай і Пиши",
  "meaning_read_write": "Значення - Читай і Пиши",
  "meaning_read_write_exercise_desc": "Прочитайте визначення і введіть правильну фразу.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Створити чат-бот",
  "find_chatbot": "Знайти чат-бот",
  "find_chatbots": "Знайти чат-боти",
  "add_chatbot": "Додати чат-бот",
  "add_chatbots": "Додати чат-боти",
  "template": "Шаблон",
  "chatbot_name": "Назва чат-бота",
  "create_scenario": "Створити рольову гру",
  "find_scenario": "Знайти рольову гру",
  "find_scenarios": "Знайти рольові ігри",
  "scenario_name": "Назва рольової гри",
  "scenarios_added": "Рольові ігри додано до теми",
  "chatbots_added": "Чат-боти додано до теми",
  "add_scenarios": "Додати рольові ігри",
  "achievements": "Досягнення",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Знайдіть теми, створені іншими вчителями, на вкладці <1>Спільнота</1>.",
  "chatbot_title": "Назва чат-бота",
  "no_scenarios_found": "Рольові ігри не знайдено",
  "no_chatbots_found": "Чат-боти не знайдено",
  "use_voice": "Використовувати голос",
  "internal_view_provider_marks": "Внутрішній перегляд · Оцінки постачальника видимі",
  "legacy": "Застарілий",
  "scan_to_open_the_classroom": "Відскануйте, щоб відкрити клас",
  "classroom_link": "Посилання на клас",
  "copy": "Копіювати",
  "tell_students_to": "Скажіть учням:",
  "invite_step_sign_in": "Увійти до свого облікового запису.",
  "invite_step_scan": "Відсканувати код або відкрити клас.",
  "invite_step_tap_join": "Натиснути {{button}}.",
  "select_exercise_phrases_intro": "Позначте списки фраз, у які хочете зіграти. Можна поєднувати списки з різних уроків.",
  "select_exercise_scenarios_intro": "Виберіть сценарій, щоб зіграти наживо з класом.",
  "source_type_phrase_lists": "Списки фраз",
  "source_type_scenarios": "Сценарії",
  "clear_all": "Очистити все",
  "n_of_m_lists_selected": "Вибрано {{n}} з {{m}} списків",
  "n_phrase_lists": "{{count}} списків фраз",
  "n_phrases": "{{count}} фраз",
  "has_definitions": "має визначення",
  "n_scenarios": "{{count}} сценаріїв",
  "n_messages": "{{count}} повідомлень",
  "n_interactions": "{{count}} взаємодій",
  "lists_and_phrases_selected": "{{lists}} списків · {{phrases}} фраз",
  "no_lists_selected": "Списки не вибрано",
  "no_scenario_selected": "Сценарій не вибрано",
  "scenario_selected": "Сценарій вибрано",
  "number_of_messages": "Кількість повідомлень",
  "max_phrases_label": "Макс.",
  "max_phrases_all": "Усі {{count}}",
  "estimated_game_time_hint": "{{questions}} запитань по {{seconds}} с кожне, плюс зворотний зв'язок між раундами.",
  "n_minutes": "{{count}} хвилин",
  "live_game_title": "{{exercise}} · {{count}} списків фраз",
  "phrases_from": "Фрази з",
  "source_card_meta": "{{topic}} · {{count}} фраз",
  "n_more": "ще",
  "waiting_for_students": "Очікуємо, поки учні приєднаються.",
  "how_students_answer": "Як учні відповідають",
  "answer_keyboard_and_word_bank": "Клавіатура та Word Bank",
  "answer_keyboard_and_word_bank_hint": "Учні друкують, а плитки зі словами — як запасний варіант.",
  "answer_keyboard_only": "Лише клавіатура",
  "answer_keyboard_only_hint": "Найважче — учні друкують усю відповідь.",
  "answer_word_bank_only": "Лише Word Bank",
  "answer_word_bank_only_hint": "Найлегше — учні торкаються слів, щоб розставити їх.",
  "time_per_question": "Час на запитання",
  "all_n_phrases": "Усі {{count}} фраз",
  "includes_one_from_each_list": "Принаймні одна фраза з кожного вибраного списку завжди включена.",
  "az": "A–Z",
  "clear_filters": "Очистити фільтри",
  "search_sections_and_topics": "Шукати розділи й теми",
  "clear_search": "Очистити пошук",
  "x_of_y": "{{shown}} з {{total}}",
  "outline_filter_count": "{{topics}} у {{sections}}",
  "topic_count_one": "{{count}} тема",
  "topic_count_other": "{{count}} тем",
  "topic_count_few": "{{count}} теми",
  "topic_count_many": "{{count}} тем",
  "section_count_one": "{{count}} розділі",
  "section_count_other": "{{count}} розділах",
  "section_count_few": "{{count}} розділах",
  "section_count_many": "{{count}} розділах",
  "no_sections_or_topics_match": "Немає розділів або тем, що відповідають",
  "try_different_keyword_or_difficulty": "Спробуйте інше ключове слово або рівень складності.",
  "nothing_matches_keyword_at_difficulty": "Немає збігів для «{{keyword}}» зі складністю {{difficulty}}. Спробуйте інше ключове слово або рівень складності.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "session_feedback": "Ваш відгук",
  "session_feedback_preparing": "Готуємо ваш відгук…",
  "session_feedback_unavailable": "Ваш відгук зараз недоступний.",
  "suggested_level": "Рекомендований рівень",
  "session_report": "Відгук про розмову",
  "view_full_report": "Переглянути повний відгук",
  "rating_approaching": "Наближається",
  "rating_meets": "Відповідає",
  "rating_exceeds": "Перевищує",
  "area_of_strength": "Сильна сторона",
  "area_for_growth": "Що покращити",
  "rating_not_yet": "Ще ні",
  "session_report_short_interaction": "Взаємодія",
  "session_report_short_vocabulary": "Словник",
  "session_report_short_function": "Функція",
  "session_report_strength": "Сильна сторона",
  "session_report_growth": "Розвиток",
  "ai_generated_report": "Відгук, створений ШІ",
  "ai_generated_report_tooltip": "Створено ШІ лише на основі цієї сесії. Рекомендований рівень і оцінки є приблизними, а не остаточним визначенням рівня.",
  "session_report_new": "Нове",
  "chatbot_mode_name": "Чат-бот - {{mode}}",
  "chatbot_message_count": "{{count}} повідомлень",
  "chatbot_message_count_one": "{{count}} повідомлення",
  "chatbot_message_count_few": "{{count}} повідомлення",
  "chatbot_message_count_many": "{{count}} повідомлень",
  "chatbot_message_count_other": "{{count}} повідомлень",
  "attempt_count": "Спроб: {{count}}",
  "attempt_count_one": "Спроб: {{count}}",
  "attempt_count_other": "Спроб: {{count}}",
  "of_total_correct": "з {{total}} правильно",
  "attempts_to_review": "Спроби для перегляду",
  "attempts_not_shown": "Не показано спроб: {{items, list}}",
  "count_correct": "{{count}} правильно",
  "count_incorrect": "{{count}} неправильно",
  "count_skipped": "{{count}} пропущено",
  "count_partially_correct": "{{count}} частково правильно",
  "view_all_count": "Переглянути всі ({{count}})",
  "view_attempt": "Переглянути спробу",
  "scenario_description_default": "Цей сценарій допомагає учням упевнено говорити {{learnLang}}."
}
